export default {
      id: "search-xl-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#search-xl-usage",
      toString: function () {
        return this.url;
      }
    }